import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
  standalone: false,
})
export class LandingComponent {
  constructor(private router: Router) {}
  signIn() {
    this.router.navigate(['/bootstrap']);
  }
  signUp() {
    this.router.navigate(['/manage/account-setup']);
  }
}


